import { FC } from "react";
// components
import PageHeading from "../components/PageHeading";
// styles
import styles from "../styles/pages/estimation/EstimationPage.module.css";
import Footer from "../components/Footer";
import { IWidgetConfiguration } from "../merchantConfig";
import ContributionOptions from "../components/ContributionOptions";
import CompensationTips from "../components/CompensationTips";

interface IEntryPage {
  setSelectedCurrency: (currency: string) => void;
  setEntryOptionSelected: (entryOptionSelected: boolean) => void;
  setOffsetAmount: (amount: number) => void;
  makeQuote: (amount: number, currency: string, merchantCode: string) => void;
  widgetConfiguration: IWidgetConfiguration;
  merchantCode: string;
  setActiveStep: (step: number) => void;
}

const EntryPage: FC<IEntryPage> = ({
  setSelectedCurrency,
  setOffsetAmount,
  widgetConfiguration,
  setEntryOptionSelected,
  makeQuote,
  setActiveStep,
  merchantCode
}) => {

  return (
    <div className={`${styles.container} delayed-fadein`}>
      <div>
        <PageHeading
          title={'Your contribution'}
          activeStep={0}
          setActiveStep={setActiveStep}
        />

        <div className={styles.marginTop}>
          <p className={styles.textBold}>{"Choose your contribution to get started."}</p>
        </div>

        <div className={styles.marginTop}>
          <ContributionOptions
            config={widgetConfiguration.entryPage}
            merchantCode={merchantCode}
            setOffsetAmount={setOffsetAmount}
            makeQuote={makeQuote}
            setCurrency={setSelectedCurrency}
            setEntryOptionSelected={setEntryOptionSelected}
          />
        </div>
      </div>
      <div>
        <div>
          <p className={styles.textBold}>{"How can I compensate for my carbon footprint?"}</p>
        </div>

        <CompensationTips />
      </div>
      {!widgetConfiguration.hidePoweredBy && <Footer/>}
    </div>
  );
};

export default EntryPage;
